/* * * * * * * * * * * * * * * * *
 * Pagination
 * javascript page navigation
 * * * * * * * * * * * * * * * * */

var Pagination = {
  code: "",

  // --------------------
  // Utility
  // --------------------

  // converting initialize data
  Extend: function (data) {
    data = data || {};
    Pagination.size = data.size || 300;
    Pagination.page = data.page || 1;
    Pagination.step = data.step || 3;
  },

  // add pages by number (from [s] to [f])
  Add: function (s, f) {
    for (var i = s; i < f; i++) {
      Pagination.code += "<a>" + i + "</a>";
    }
  },

  // add last page with separator
  Last: function () {
    Pagination.code += "<i>...</i><a>" + Pagination.size + "</a>";
  },

  // add first page with separator
  First: function () {
    Pagination.code += "<a>1</a><i>...</i>";
  },

  // --------------------
  // Handlers
  // --------------------

  // change page
  Click: function () {
    Pagination.page = +this.innerHTML;
    Pagination.Start();
    console.log(this.innerHTML)
    return this.innerHTML;
  },

  // previous page
  Prev: function () {
    Pagination.page--;
    if (Pagination.page < 1) {
      Pagination.page = 1;
    }
    Pagination.Start();
  },

  // next page
  Next: function () {
    Pagination.page++;
    if (Pagination.page > Pagination.size) {
      Pagination.page = Pagination.size;
    }
    Pagination.Start();
  },

  // --------------------
  // Script
  // --------------------

  // binding pages
  Bind: function () {
    var a = Pagination.e.getElementsByTagName("a");
    for (var i = 0; i < a.length; i++) {
      console.log("test")
      if (+a[i].innerHTML === Pagination.page) a[i].className = "current";
      a[i].addEventListener("click", Pagination.Click, false);
    }
  },

  // write pagination
  Finish: function () {
    Pagination.e.innerHTML = Pagination.code;
    Pagination.code = "";
    Pagination.Bind();
  },

  // find pagination type
  Start: function () {
    if (Pagination.size < Pagination.step * 2 + 6) {
      Pagination.Add(1, Pagination.size + 1);
    } else if (Pagination.page < Pagination.step * 2 + 1) {
      Pagination.Add(1, Pagination.step * 2 + 4);
      Pagination.Last();
    } else if (Pagination.page > Pagination.size - Pagination.step * 2) {
      Pagination.First();
      Pagination.Add(
        Pagination.size - Pagination.step * 2 - 2,
        Pagination.size + 1
      );
    } else {
      Pagination.First();
      Pagination.Add(
        Pagination.page - Pagination.step,
        Pagination.page + Pagination.step + 1
      );
      Pagination.Last();
    }
    Pagination.Finish();
  },

  // --------------------
  // Initialization
  // --------------------

  // binding buttons
  Buttons: function (e) {
    var nav = e.getElementsByTagName("a");
    nav[0].addEventListener("click", Pagination.Prev, false);
    nav[1].addEventListener("click", Pagination.Next, false);
  },

  // create skeleton
  Create: function (e) {
    const prevIcon = `<?xml version="1.0" encoding="iso-8859-1"?>
    <!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
    <svg class="prev" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
       viewBox="0 0 483.284 483.284" xml:space="preserve">
      <polygon points="483.284,221.643 88.284,221.643 88.284,153.358 0,241.644 88.284,241.644 88.284,261.643 
        483.284,261.643 	"/>
      <polygon points="0,241.644 88.284,329.926 88.284,241.644 	"/>
    </svg>`;
    const nextIcon = `<?xml version="1.0" encoding="iso-8859-1"?>
    <!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
    <svg class="next" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
       viewBox="0 0 483.284 483.284" xml:space="preserve">
    <g>
      <polygon points="483.284,241.644 395,153.358 395,221.643 0,221.643 0,261.643 395,261.643 395,241.644 	"/>
      <polygon points="483.284,241.644 395,241.644 395,329.926 	"/>
    </g>
    </svg>`
    var html = [
      `<a class="prev wholescale-disabled">${prevIcon}</a>`, // previous button
      "<span></span>", // pagination container
      `<a class="next">${nextIcon}</a>`, // next button
    ];

    e.innerHTML = html.join("");
    Pagination.e = e.getElementsByTagName("span")[0];
    Pagination.Buttons(e);
  },

  // init
  Init: function (e, data) {
    console.log(e)
    Pagination.Extend(data);
    Pagination.Create(e);
    Pagination.Start();
  },
};
var PaginationQuestion = {
  code: "",

  // --------------------
  // Utility
  // --------------------

  // converting initialize data
  Extend: function (data) {
    data = data || {};
    PaginationQuestion.size = data.size || 300;
    PaginationQuestion.page = data.page || 1;
    PaginationQuestion.step = data.step || 3;
  },

  // add pages by number (from [s] to [f])
  Add: function (s, f) {
    for (var i = s; i < f; i++) {
      PaginationQuestion.code += "<a>" + i + "</a>";
    }
  },

  // add last page with separator
  Last: function () {
    PaginationQuestion.code += "<i>...</i><a>" + PaginationQuestion.size + "</a>";
  },

  // add first page with separator
  First: function () {
    PaginationQuestion.code += "<a>1</a><i>...</i>";
  },

  // --------------------
  // Handlers
  // --------------------

  // change page
  Click: function () {
    PaginationQuestion.page = +this.innerHTML;
    PaginationQuestion.Start();
    console.log(this.innerHTML)
    return this.innerHTML;
  },

  // previous page
  Prev: function () {
    PaginationQuestion.page--;
    if (PaginationQuestion.page < 1) {
      PaginationQuestion.page = 1;
    }
    PaginationQuestion.Start();
  },

  // next page
  Next: function () {
    PaginationQuestion.page++;
    if (PaginationQuestion.page > PaginationQuestion.size) {
      PaginationQuestion.page = PaginationQuestion.size;
    }
    PaginationQuestion.Start();
  },

  // --------------------
  // Script
  // --------------------

  // binding pages
  Bind: function () {
    var a = PaginationQuestion.e.getElementsByTagName("a");
    for (var i = 0; i < a.length; i++) {
      console.log("test")
      if (+a[i].innerHTML === PaginationQuestion.page) a[i].className = "current";
      a[i].addEventListener("click", PaginationQuestion.Click, false);
    }
  },

  // write PaginationQuestion
  Finish: function () {
    PaginationQuestion.e.innerHTML = PaginationQuestion.code;
    PaginationQuestion.code = "";
    PaginationQuestion.Bind();
  },

  // find PaginationQuestion type
  Start: function () {
    if (PaginationQuestion.size < PaginationQuestion.step * 2 + 6) {
      PaginationQuestion.Add(1, PaginationQuestion.size + 1);
    } else if (PaginationQuestion.page < PaginationQuestion.step * 2 + 1) {
      PaginationQuestion.Add(1, PaginationQuestion.step * 2 + 4);
      PaginationQuestion.Last();
    } else if (PaginationQuestion.page > PaginationQuestion.size - PaginationQuestion.step * 2) {
      PaginationQuestion.First();
      PaginationQuestion.Add(
        PaginationQuestion.size - PaginationQuestion.step * 2 - 2,
        PaginationQuestion.size + 1
      );
    } else {
      PaginationQuestion.First();
      PaginationQuestion.Add(
        PaginationQuestion.page - PaginationQuestion.step,
        PaginationQuestion.page + PaginationQuestion.step + 1
      );
      PaginationQuestion.Last();
    }
    PaginationQuestion.Finish();
  },

  // --------------------
  // Initialization
  // --------------------

  // binding buttons
  Buttons: function (e) {
    var nav = e.getElementsByTagName("a");
    nav[0].addEventListener("click", PaginationQuestion.Prev, false);
    nav[1].addEventListener("click", PaginationQuestion.Next, false);
  },

  // create skeleton
  Create: function (e) {
    const prevIcon = `<?xml version="1.0" encoding="iso-8859-1"?>
    <!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
    <svg class="prev" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
       viewBox="0 0 483.284 483.284" xml:space="preserve">
      <polygon points="483.284,221.643 88.284,221.643 88.284,153.358 0,241.644 88.284,241.644 88.284,261.643 
        483.284,261.643 	"/>
      <polygon points="0,241.644 88.284,329.926 88.284,241.644 	"/>
    </svg>`;
    const nextIcon = `<?xml version="1.0" encoding="iso-8859-1"?>
    <!-- Uploaded to: SVG Repo, www.svgrepo.com, Generator: SVG Repo Mixer Tools -->
    <svg class="next" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
       viewBox="0 0 483.284 483.284" xml:space="preserve">
    <g>
      <polygon points="483.284,241.644 395,153.358 395,221.643 0,221.643 0,261.643 395,261.643 395,241.644 	"/>
      <polygon points="483.284,241.644 395,241.644 395,329.926 	"/>
    </g>
    </svg>`
    var html = [
      `<a class="prev wholescale-disabled">${prevIcon}</a>`, // previous button
      "<span></span>", // PaginationQuestion container
      `<a class="next">${nextIcon}</a>`, // next button
    ];

    e.innerHTML = html.join("");
    PaginationQuestion.e = e.getElementsByTagName("span")[0];
    PaginationQuestion.Buttons(e);
  },

  // init
  Init: function (e, data) {
    console.log(e)
    PaginationQuestion.Extend(data);
    PaginationQuestion.Create(e);
    PaginationQuestion.Start();
  },
};
/* * * * * * * * * * * * * * * * *
 * Initialization
 * * * * * * * * * * * * * * * * */

var init = function () {
  window["reviewPaginationInit"] = function (pageCount) {
    Pagination.Init(document.getElementById("review-pagination"), {
      size: pageCount, // pages size
      page: 1, // selected page
      step: 3, // pages before and after current
    });
    if(pageCount == 1) {
      document.querySelector("#review-pagination .next").classList.add("wholescale-disabled");
    }
    else {
      document.querySelector("#review-pagination .next").classList.remove("wholescale-disabled");
    }
    document.querySelectorAll("#review-pagination > *")?.forEach((item) => {
      item.addEventListener("click", (event) => {
        if(event.target.tagName === 'I' || event.target.classList.contains("current")) {
          return
        }
        document.querySelector("[reviews-container]").classList.add("loading");
        const page = document.querySelector("#review-pagination .current").textContent;
        if (event.target.classList.contains("prev")) {
          let prevPage = Number(page);
          window.fetchReviewsList(prevPage);
        } else if (event.target.classList.contains("next")) {
          console.log("next");
          let nextPage = page
          window.fetchReviewsList(nextPage);
        } else {
          window.fetchReviewsList(page);
        }
        if(page > 1) {
          document.querySelector("#review-pagination .prev").classList.remove("wholescale-disabled");
          document.querySelector("#review-pagination .next").classList.remove("wholescale-disabled");
        }
        else {
          document.querySelector("#review-pagination .prev").classList.add("wholescale-disabled");
          document.querySelector("#review-pagination .next").classList.remove("wholescale-disabled");
        }
        if(page == pageCount) {
          document.querySelector("#review-pagination .next").classList.add("wholescale-disabled");
        }
      });
    });
  };
  window["questionPaginationInit"] = function (pageCount) {
    PaginationQuestion.Init(document.getElementById("question-pagination"), {
      size: pageCount, // pages size
      page: 1, // selected page
      step: 3, // pages before and after current
    });
    if(pageCount == 1) {
      document.querySelector("#question-pagination .next").classList.add("wholescale-disabled");
    }
    else {
      document.querySelector("#question-pagination .next").classList.remove("wholescale-disabled");
    }
    document.querySelectorAll("#question-pagination > *")?.forEach((item) => {
      item.addEventListener("click", (event) => {
        if(event.target.tagName === 'I' || event.target.classList.contains("current")) {
          return
        }
        const page = document.querySelector("#question-pagination .current").textContent;
        document.querySelector("[questions-container]").classList.add("loading");
        if (event.target.classList.contains("prev")) {
          let prevPage = page;
          window.fetchQuestionsList(prevPage);
        } else if (event.target.classList.contains("next")) {
          console.log("inside next")
          let nextPage =
            document.querySelector("#question-pagination .current").textContent +
            1;
          window.fetchQuestionsList(nextPage);
        } else {
          window.fetchQuestionsList(event.target.textContent);
        }
        if(event.target.textContent > 1) {
          document.querySelector("#question-pagination .prev").classList.remove("wholescale-disabled");
        }
        else {
          document.querySelector("#question-pagination .prev").classList.add("wholescale-disabled");
        }
        if(event.target.textContent == pageCount) {
          document.querySelector("#question-pagination .next").classList.remove("wholescale-disabled");
        }
      });
    });
  };
};

document.addEventListener("DOMContentLoaded", init, false);
